<!--
 * @Author: LiZhiWei
 * @Description: AppFooter
-->
<template>
  <footer class="bg-black text-white py-60px lt-sm:py-40px sm:pt-130px sm:pb-60px lt-sm:pt-88px">
    <div class="landing-container">
      <!-- 顶部区域：链接列表 + 联系方式 -->
      <div class="flex flex-col sm:flex-row justify-between items-start gap-60px sm:gap-0">
        <!-- 左侧链接列表 -->
        <nav
          class="flex flex-wrap gap-40px sm:gap-80px sm:w-600px justify-between sm:justify-start lt-sm:hidden"
        >
          <!-- 产品 -->
          <div class="text-left flex-1">
            <h3 class="mb-16px font-s-16px text-white pf-sc-semibold">产品</h3>
            <ul class="flex flex-col gap-14px">
              <li>
                <NuxtLink
                  class="font-s-14px lh-20px text-#9CA0A7 no-underline transition-colors duration-300 hover:text-white"
                  to="https://www.huiguanjia.cn/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  绘管家物业云平台
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  class="font-s-14px lh-20px text-#9CA0A7 no-underline transition-colors duration-300 hover:text-white"
                  to="https://www.huifuwu.cn/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  绘服务居民平台
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  class="font-s-14px lh-20px text-#9CA0A7 no-underline transition-colors duration-300 hover:text-white"
                  to="/"
                >
                  智能硬件物联
                </NuxtLink>
              </li>
            </ul>
          </div>

          <!-- 解决方案 -->
          <div class="text-left flex-1">
            <h3 class="mb-16px font-s-16px text-white pf-sc-semibold">解决方案</h3>
            <ul class="flex flex-col gap-14px">
              <li>
                <NuxtLink
                  class="font-s-14px lh-20px text-#9CA0A7 no-underline transition-colors duration-300 hover:text-white"
                  to="/solutions/SFS-001"
                >
                  智慧收费系统
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  class="font-s-14px lh-20px text-#9CA0A7 no-underline transition-colors duration-300 hover:text-white"
                  to="/solutions/CTD-002"
                >
                  综合工单调度
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  class="font-s-14px lh-20px text-#9CA0A7 no-underline transition-colors duration-300 hover:text-white"
                  to="/solutions/MPI-003"
                >
                  移动巡检巡更
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  class="font-s-14px lh-20px text-#9CA0A7 no-underline transition-colors duration-300 hover:text-white"
                  to="/solutions/SPLM-004"
                >
                  智慧车场管理
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  class="font-s-14px lh-20px text-#9CA0A7 no-underline transition-colors duration-300 hover:text-white"
                  to="/solutions/DDC-005"
                >
                  数据决策中心
                </NuxtLink>
              </li>
            </ul>
          </div>

          <!-- 关于绘家 -->
          <div class="text-left flex-1">
            <h3 class="mb-16px font-s-16px text-white pf-sc-semibold">关于绘家</h3>
            <ul class="flex flex-col gap-14px">
              <li>
                <NuxtLink
                  class="font-s-14px lh-20px text-#9CA0A7 no-underline transition-colors duration-300 hover:text-white"
                  to="/about"
                >
                  公司简介
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  class="font-s-14px lh-20px text-#9CA0A7 no-underline transition-colors duration-300 hover:text-white"
                  to="/case-studies"
                >
                  客户案例
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  class="font-s-14px lh-20px text-#9CA0A7 no-underline transition-colors duration-300 hover:text-white"
                  to="/honor-qualification"
                >
                  荣誉资质
                </NuxtLink>
              </li>
              <!-- <li>
                <NuxtLink
                  class="font-s-14px lh-20px text-#9CA0A7 no-underline transition-colors duration-300 hover:text-white"
                  to="/"
                >
                  加入我们
                </NuxtLink>
              </li> -->
            </ul>
          </div>
        </nav>

        <!-- 右侧联系方式 -->
        <div class="flex flex-col sm:flex-row gap-40px sm:gap-123px w-full sm:w-auto">
          <div class="text-left lt-sm:text-center">
            <div class="font-s-16px lh-22px text-white pf-sc-semibold">关注或联系我们</div>
            <div class="font-s-14px lh-22px text-#94a3b8 mt-16px">
              <span class="lt-sm:hidden">电话：400-600-7709</span>
              <i
                class="i-custom-mobile-phone lt-sm:h-58px lt-sm:w-552px"
                aria-label="电话：400-600-7709"
              ></i>
            </div>
            <div class="font-s-14px lh-22px text-#94a3b8 mt-16px">
              地址：海南省海口市美兰区西溪里商业街7号楼一楼
            </div>
          </div>
          <div class="flex flex-col items-start sm:items-center lt-sm:items-center">
            <i class="i-custom-qrcode wh-136px" aria-label="微信扫码关注我们"></i>
            <div class="mt-12px font-s-16px text-#white lh-22px pf-sc-regular">扫一扫关注我们</div>
          </div>
        </div>
      </div>

      <!-- 底部区域：Logo + 版权 -->
      <div
        class="mt-40px sm:mt-80px pt-0 flex flex-col sm:flex-row justify-between items-center text-12px text-#64748b"
      >
        <!-- 左侧 Logo -->
        <div class="flex items-center gap-10px mb-20px sm:mb-0">
          <i class="i-custom-logo-white h-31px w-147px" aria-label="绘家科技Logo"></i>
        </div>

        <!-- 右侧 版权 -->
        <div class="flex flex-col py-8px gap-36px sm:flex-row items-center sm:gap-20px">
          <span>© 2026 海南绘家科技有限公司版权所有</span>
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            class="flex items-center gap-4px hover:text-white transition-colors"
            aria-label="琼ICP备2026002456号-1"
          >
            <div
              class="wh-14px bg-contain bg-no-repeat bg-center"
              aria-hidden="true"
              style="
                background-image: url('https://img.alicdn.com/tfs/TB1..50QpXXXXX7XpXXXXXXXXXX-40-40.png');
              "
            ></div>
            琼ICP备2026002456号-1
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss"></style>
